import { DEVICE } from '@net0-calc/common/assets/styles';
import styled from 'styled-components/macro';

export const RedAccentHeading = styled.div`
  position: relative;
  padding-left: 16px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    width: 4px;
    height: 28px;
    background-color: var(--color2);
    border-radius: 2px;
  }

  @media ${DEVICE.laptop} {
    padding-left: 20px;
    &::before {
      height: 32px;
      top: 4px;
    }
  }
`;
